import { render, staticRenderFns } from "./tao.vue?vue&type=template&id=1ffb0b6e&scoped=true&"
import script from "./tao.vue?vue&type=script&lang=js&"
export * from "./tao.vue?vue&type=script&lang=js&"
import style0 from "./tao.vue?vue&type=style&index=0&id=1ffb0b6e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffb0b6e",
  null
  
)

export default component.exports